import React from "react";
import { Crown } from "lucide-react";
import logo from "../images/logo.jpg"


export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-10 text-sm text-neutral-400 bg-black">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-8 text-center sm:text-left">
        
        {/* Top Footer: Brand + Links */}
        <div className="flex flex-col md:flex-row justify-between gap-10 md:gap-6">
          
          {/* Logo/Brand */}
          <div className="flex items-center gap-2 justify-center">
          <img
              src={logo}
              alt= "logo"
              className="h-20 w-24"
              />
            {/* <span className="font-medium text-neutral-200 hover:text-yellow-200 transition">
              Beyond Box
            </span> */}
          </div>

          {/* Links Grid */}
            
            {/* Products */}
            <ul className="space-y-2">
              <li className="text-neutral-300 font-medium">Products</li>
              <li><a href="#products" className="hover:text-yellow-200">Profiles</a></li>
              <li><a href="#products" className="hover:text-yellow-200">Sheets</a></li>
              <li><a href="#catalogue" className="hover:text-yellow-200">Catalogue</a></li>
            </ul>

            {/* Company */}
            <ul className="space-y-2">
              <li className="text-neutral-300 font-medium">Company</li>
              <li><a href="#about" className="hover:text-yellow-200">About</a></li>
              <li><a href="#offerings" className="hover:text-yellow-200">Offerings</a></li>
              <li><a href="#contact" className="hover:text-yellow-200">Contact</a></li>
            </ul>

            {/* Legal */}
            {/* <ul className="space-y-2">
              <li className="text-neutral-300 font-medium">Legal</li>
              <li><a href="#" className="hover:text-yellow-200">Privacy</a></li>
              <li><a href="#" className="hover:text-yellow-200">Terms</a></li>
            </ul> */}
        </div>

        {/* Bottom Footer */}
        <div className="text-center text-neutral-500 text-xs sm:text-sm">
          © {new Date().getFullYear()} Beyond Box. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
